export default __webpack_public_path__ + "static/media/cs_icon_01.2f028582.png";